import {useDraggable} from '@dnd-kit/core';
import { ProductModel } from 'models/ProductModel';

export function Draggable(props: { id: number, product: ProductModel, children: React.ReactNode, fromCart?: boolean}) {
  const {attributes, listeners, setNodeRef, transform} = useDraggable({
    id: props.id,
    data: {
      productId: props.product.productId,
      fromCart: props.fromCart
    },
    disabled: false
  });
  
  // const style = transform ? {
  //   transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`
  // } : undefined;

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    touchAction: "none", // Important pour empêcher le scroll pendant le drag
  };

  
  return (
    <div 
      ref={setNodeRef} 
      style={style} 
      className={`${transform && 'realtive z-50'} ${props.fromCart && transform && 'absolute w-[300px]'}`} 
      {...listeners} 
      {...attributes}
    >
      {props.children}
    </div>
  );
}